import Vue from 'vue';
import store from './store';
import i18n from './i18n';
import { DateTime } from 'luxon';
import { localize, resolveLocale } from '@/utils/i18n-helpers';

Vue.filter('capitalize', (value: string) => {
	if (!value) {
		return '';
	}

	return value.toString().charAt(0).toUpperCase() + value.slice(1);
});

/**
 * This helper filter has a copy in Remy, any change of logic here must be replicated there.
 */
Vue.filter('formatDate', (value: string, format: string = 'dd/MM/yyyy', timezone?: string) => {
	if (!value) {
		return '';
	}
	// If no timezone is provided, use the local timezone
	return DateTime.fromISO(value).setLocale(resolveLocale(i18n.locale)).setZone(timezone || DateTime.local().zoneName).toFormat(format);
});

/**
 * This helper filter has a copy in Remy, any change of logic here must be replicated there.
 */
Vue.filter('localize', (element: LocaleElement, field: string) => {
	const restaurant: Restaurant = store.getters['auth/getRestaurant'];
	return localize(element, field, i18n.locale, restaurant.locales);
});